// extracted by mini-css-extract-plugin
export default {"wrapper":"Star_wrapper__X9U54"};